module.exports = __webpack_public_path__ + "img/eu.07f89ccc.png";